<template>
  <v-bottom-navigation
    :class="
      getFooterTemplate.type === 'hide' ? 'd-none align-center' : 'align-center'
    "
    absolute
  >
    <!-- Please dinamyc this code, for all text, action, etc -->
    <!-- Menu Navigation - 1-Button for claim service (will be delete after dynamic) -->
    <v-container
      v-if="getFooterTemplate.type === '1-button' && getFooterTemplate.extra"
      class="menu-navigation--1-button"
    >
      <v-row class="align-center justify-center mx-0" style="height: 56px">
        <v-col
          v-for="(extra, i) in getFooterTemplate.extra.item"
          :key="`${extra.text}${i}`"
          :cols="getFooterTemplate.extra.item.length > 1 ? 5 : 12"
          class="pa-1 ml-2 mr-2"
        >
          <template v-if="extra.type === 'BUTTON'">
            <v-btn block light color="var(--bg)" @click="extra.action">
              {{ extra.text }}
            </v-btn>
          </template>

          <template v-else-if="extra.type === 'INFO'">
            <div class="font-weight-bold" v-html="extra.text"></div>
          </template>

          <template v-else>
            <div class="font-weight-bold" style="font-size: 15px">
              {{ extra.text }}
            </div>
          </template>
        </v-col>
      </v-row>
    </v-container>

    <!-- Menu Navigation - 1-Button -->
    <v-container
      v-else-if="getFooterTemplate.type === '1-button'"
      class="menu-navigation--1-button"
    >
      <!-- Footer - Top Des -->
      <!-- <v-row
        v-if="getShowDescFooter"
        class="pt-3 pb-0"
        style="height: 56px"
      >
        <v-col
          class="pl-0 pt-0 pr-0 pb-0"
        >
          <div
            class="container-top-footer"
          >
            <div
              class="container-top-footer__desc"
            >
              {{ getDesc }}
            </div>
            <div
              class="container-top-footer__total"
            >
              {{ getCreatePolicy.totalPrice | currencyFilter }}
            </div>
          </div>
        </v-col>
      </v-row> -->
      <v-row v-if="getShowDescFooter" class="full-width" style="height: 56px">
        <v-col class="pa-0 full-height">
          <v-row class="full-width full-height container-top-footer">
            <v-col class="pa-0 full-height container-top-footer__desc">
              {{ getDesc }}
            </v-col>

            <v-col class="pa-0 full-height container-top-footer__total">
              {{ getCreatePolicy.totalPrice | currencyFilter }}
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row class="full-width container-bottom-footer" style="height: 56px">
        <v-col
          class="pa-0"
          style="display: flex; justify-content: center; align-items: center"
        >
          <v-btn
            :disabled="
              getCreatePolicy.isValid &&
              getCreatePolicy.prices.cost[0] &&
              getCreatePolicy.prices.cost[0] !== '0' &&
              getPrice <= 65000000
                ? false
                : true
            "
            block
            light
            color="var(--bg)"
            @click="submitHandler"
          >
            {{ getFooterTemplate.text || "Submit" }}
          </v-btn>
        </v-col>
      </v-row>
    </v-container>

    <!-- Menu Navigation - 2-Button -->
    <v-container
      v-else-if="getFooterTemplate.type === '2-button'"
      class="menu-navigation--2-button"
    >
      <v-row v-if="getShowDescFooter" class="full-width" style="height: 56px">
        <!-- <v-col
          class="pl-0 pt-0 pr-0 pb-0"
        >
          <div
            class="container-top-footer"
          >
            <div
              class="container-top-footer__desc"
            >
              {{ getDesc }}
            </div>
            <div
              class="container-top-footer__total"
            >
              {{ getCreatePolicy.totalPrice | currencyFilter }}
            </div>
          </div>
        </v-col> -->
        <v-col class="pa-0 full-height">
          <v-row class="full-width full-height container-top-footer">
            <v-col class="pa-0 full-height container-top-footer__desc">
              {{ getDesc }}
            </v-col>

            <v-col class="pa-0 full-height container-top-footer__total">
              {{ getCreatePolicy.totalPrice | currencyFilter }}
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row class="full-width container-bottom-footer" style="height: 56px">
        <v-col
          class="pa-0 pr-2"
          style="height: 100%; display: flex; align-items: center"
        >
          <v-btn
            block
            light
            color="secondary"
            @click="getFooterTemplate.action.payWithCash"
          >
            Pay to Cashier
          </v-btn>
        </v-col>

        <v-col
          class="pa-0"
          style="height: 100%; display: flex; align-items: center"
        >
          <v-btn
            block
            light
            color="success"
            @click="getFooterTemplate.action.sendPaymentLink"
          >
            Send Payment Link
          </v-btn>
        </v-col>
      </v-row>
    </v-container>

    <!-- Menu Navigation - Default (3-button) -->
    <div v-else class="bottom-wrapper">
      <!-- menu: dynamic menu -->
      <a
        v-for="(menuItem, index) in menuFiltered"
        :key="index"
        :class="[{ 'btn-active': isActiveRoute(menuItem) }]"
        @click="navigationClicked(menuItem)"
      >
        <v-icon>{{ menuItem.icon }}</v-icon>

        <span class="nav-text">
          {{
            $helpers.translateKeyContent(
              "QoalaExternalDashboardGadget",
              menuItem.text,
            )
          }}
        </span>
      </a>
    </div>

    <!-- modal (for multiple product industry) -->
    <mobile-app-multiple-dropdown
      v-if="toggleMultipleDropdown"
      ref="multipleDropdown"
      v-model="selectedDropdown"
      is-mobile
      :title="dropdownTitleWording"
      :items="multipleDropdownList"
      @close="toggleMultipleDropdown = false"
      @input="dropdownClicked"
    ></mobile-app-multiple-dropdown>
  </v-bottom-navigation>
</template>

<script>
import {
  mdiViewDashboard,
  mdiFileDocument,
  mdiShield,
  mdiWallet,
  mdiAccount,
} from "@mdi/js";
import { filter, find, forEach, get, map } from "lodash-es";

import MobileAppMultipleDropdown from "@/components/MobileAppMultipleDropdown";

export default {
  name: "MobileAppFooter",

  components: {
    MobileAppMultipleDropdown,
  },

  props: {
    menu: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      mdiViewDashboard,
      mdiFileDocument,
      mdiShield,
      mdiWallet,
      mdiAccount,
      // multiple dropdown
      dropdownTitleWording: "",
      toggleMultipleDropdown: false,
      multipleDropdownList: [],
      selectedDropdown: null,
      clickedItem: null,
    };
  },

  computed: {
    userData() {
      return this.$store.getters["auth/getUserData"];
    },

    getCreatePolicy() {
      return this.$store.getters[`products/${this.getModule}/getCreatePolicy`];
    },

    getPrice() {
      return (
        this.getCreatePolicy.prices.cost[0] &&
        this.$helpers.priceFormatToNumber(this.getCreatePolicy.prices.cost[0])
      );
    },

    getButtonActive() {
      return get(this.$store, 'getters["mobile/getButtonActive"]', {});
    },

    getFooterTemplate() {
      return get(this.$store, 'getters["mobile/getFooterTemplate"]', {});
    },

    getShowDescFooter() {
      return this.$store.getters[`mobile/getShowDescFooter`];
    },

    getDesc() {
      return `${
        this.getCreatePolicy.prices.cost[0] ? "Total Premium Amount" : ""
      }
            ${
              this.getCreatePolicy.prices.cost[0] &&
              this.getCreatePolicy.prices.cost[0] !== "0" &&
              this.getCreatePolicy.buyback
                ? " + "
                : ""
            } ${this.getCreatePolicy.buyback ? "Buyback" : ""}`;
    },

    shouldAccessCommission() {
      return (
        this.$role.isPartner() &&
        this.$permission.permissionCommissionMobilePage() &&
        // TURN OFF COMMISSION DETAIL & COMMISSION MOBILE FOR RELEASE
        !this.$helpers.turnOffCommission()
      );
    },

    menuFiltered() {
      // filtered menu based on permission
      const baseMenu = [
        {
          text: "Dashboard",
          name: "dashboard",
          icon: mdiViewDashboard,
        },
        {
          text: "Policy List",
          name: "policy",
          icon: mdiFileDocument,
          items: [],
        },
        {
          text: "Claim List",
          name: "claim",
          icon: mdiShield,
          items: [],
        },
        {
          text: "Commission",
          name: "commission",
          icon: mdiWallet,
        },
        {
          text: "Profile",
          name: "profile",
          icon: mdiAccount,
        },
      ];

      const productList = filter(this.menu, (item) => {
        const isProductCategory = map(
          this.$store.getters["organization/getOrganizationsProductCategories"],
          (category) => category.slug,
        ).includes(item.name);

        return isProductCategory;
      });

      forEach(productList, (item) => {
        // check if product has permission for policy list
        if (item.name === "gadget") {
          if (
            this.hasPermission("common.product.policy.list") ||
            this.hasPermission(`product.${item.name}.policy.list`) ||
            this.isQoalaSuperAdmin
          ) {
            const filterItem = item;
            // delete unused key: items
            delete filterItem.items;
            baseMenu[1].items.push(filterItem);
          }

          // check if product has permission for claim list
          if (
            (this.hasPermission("common.product.claim.list") ||
              this.hasPermission(`product.${item.name}.claim.list`) ||
              this.isQoalaSuperAdmin) &&
            !this.$helpers.isQoalaAdmin()
          ) {
            const filterItem = item;
            // delete unused key: items
            delete filterItem.items;
            baseMenu[2].items.push(filterItem);
          }
        }
      });

      const menu = filter(
        baseMenu,
        (itemMenu) =>
          itemMenu.name === "dashboard" ||
          itemMenu.name === "profile" ||
          (itemMenu.name === "commission" && this.shouldAccessCommission) ||
          (!(
            itemMenu.name === "dashboard" ||
            itemMenu.name === "profile" ||
            itemMenu.name === "commission"
          ) &&
            itemMenu.items.length),
      );

      return menu;
    },
  },

  methods: {
    navigationClicked(item) {
      // dashboard & profile
      if (
        typeof item.items === "undefined" ||
        item.items === null ||
        !item.items.length
      ) {
        this.$router.push(`/${item.name}`);
      } else if (item.items.length < 2 && item.items.length > 0) {
        // product industry only one --> directly open the page
        // item.items[0].name === product industry
        this.$router.push(`/${item.items[0].name}/${item.name}`);
      } else {
        // assign title
        this.dropdownTitleWording = item.text;

        // flag policy/claim list
        this.clickedItem = item;

        // assign list to modal
        this.multipleDropdownList = item.items;

        // assign selected dropdown (active route)
        if (this.getListingType.includes(item.name)) {
          this.selectedDropdown = find(
            item.items,
            (itemProduct) => itemProduct.name === this.getModule,
          );
        } else {
          this.selectedDropdown = null;
        }

        // launch multiple dropdown modal
        this.toggleMultipleDropdown = true;
      }
    },

    isActiveRoute(item) {
      const routeName =
        get(this.$route, "name", "") !== null
          ? get(this.$route, "name", "")
          : "";

      return routeName.includes(item.name);
    },

    dropdownClicked() {
      this.$router.push(
        `/${this.selectedDropdown.name}/${this.clickedItem.name}`,
      );

      // after moving route, reset multipledropdown data
      this.dropdownTitleWording = "";
      this.toggleMultipleDropdown = false;
      this.multipleDropdownList = [];
      this.selectedDropdown = null;
      this.clickedItem = null;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep.v-bottom-navigation {
  position: fixed !important;
  bottom: 0px !important;
  height: fit-content !important;
  z-index: 99;

  .bottom-wrapper {
    height: 56px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: $tabWidth;
    padding: 0px 30px;

    @media (max-width: $tabWidth) {
      width: 100%;
    }

    .v-btn {
      color: unset !important;
      text-decoration: unset;

      &.v-btn--active {
        color: var(--bg) !important;
      }
    }

    a {
      text-decoration: none;
      display: flex;
      flex-flow: column nowrap;

      &.btn-active {
        .v-icon {
          color: var(--bg);
        }

        .nav-text {
          font-size: 10px;
          color: var(--bg);
        }
      }

      .nav-text {
        font-size: 10px;
        color: $greyTextColor;
      }
    }
  }
}
</style>
